var _circle, _circle2;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgDryer(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "100%",
    height: "100%",
    viewBox: "0 0 300 300",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    xmlSpace: "preserve",
    style: {
      fillRule: "evenodd",
      clipRule: "evenodd",
      strokeLinejoin: "round",
      strokeMiterlimit: 2
    },
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    d: "M119.558,219.558c2.524,-0.946 3.786,-3.785 2.839,-6.309l0,-0.315c-1.577,-4.417 -2.523,-8.518 -2.523,-12.303c0.315,-3.786 1.577,-7.571 3.47,-11.987c0.946,-2.209 1.893,-4.732 2.839,-7.256c0.946,-2.839 2.208,-6.309 2.208,-9.464c0.316,-3.47 -0.315,-6.624 -1.577,-9.779c-0.631,-1.577 -1.262,-3.154 -2.208,-4.416c-0.947,-1.578 -1.578,-2.524 -3.155,-4.101c-0.946,-1.262 -2.839,-1.893 -4.416,-1.262c-2.524,0.631 -4.101,3.155 -3.47,5.363l0.315,1.892c0,0.631 0.631,1.578 0.946,2.524c0.316,0.946 0.316,1.893 0.631,2.839c0.316,1.893 0,3.786 -0.315,5.678c-0.316,1.893 -0.946,3.47 -1.893,5.363l-3.154,7.256c-0.947,2.523 -2.209,5.363 -2.839,8.202c-0.631,3.154 -1.262,6.309 -0.947,9.779c0.316,6.624 3.47,12.618 7.256,17.035c1.892,1.261 4.101,1.892 5.993,1.261Z",
    style: {
      fillRule: "nonzero"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M152.05,219.558c2.524,-0.946 3.786,-3.785 2.84,-6.309l-0,-0.315c-1.578,-4.417 -2.524,-8.518 -2.524,-12.303c0.315,-3.786 1.577,-7.571 3.47,-11.987c0.946,-2.209 1.893,-4.732 2.839,-7.256c0.946,-2.839 2.208,-6.309 2.208,-9.464c0.316,-3.47 -0.315,-6.624 -1.577,-9.779c-0.631,-1.577 -1.262,-3.154 -2.208,-4.416c-0.947,-1.578 -1.577,-2.524 -3.155,-4.101c-0.946,-1.262 -2.839,-1.578 -4.416,-1.262c-2.524,0.631 -4.101,3.155 -3.47,5.363l0.946,1.577c0,0.631 0.631,1.577 0.947,2.524c0.315,0.946 0.315,1.892 0.63,2.839c0.316,1.893 0,3.785 -0.315,5.678c-0.315,1.893 -0.946,3.47 -1.893,5.363l-3.154,6.94c-0.947,2.524 -2.209,5.363 -2.839,8.202c-0.631,3.154 -1.262,6.309 -0.947,9.779c0.316,6.625 3.47,12.618 7.256,17.035c1.262,1.892 3.154,2.523 5.362,1.892Z",
    style: {
      fillRule: "nonzero"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M184.227,219.558c2.524,-0.946 3.786,-3.785 2.839,-6.309l0,-0.315c-1.577,-4.417 -2.523,-8.518 -2.523,-12.303c0.315,-3.786 1.577,-7.571 3.47,-11.987c0.946,-2.209 1.892,-4.732 2.839,-7.256c0.946,-2.839 2.208,-6.309 2.208,-9.464c0.315,-3.47 -0.316,-6.624 -1.577,-9.779c-0.631,-1.577 -1.262,-3.154 -2.209,-4.416c-0.946,-1.578 -1.577,-2.524 -3.154,-4.101c-0.946,-1.262 -2.839,-1.893 -4.417,-1.262c-2.523,0.631 -4.1,3.155 -3.47,5.363l0.316,1.892c-0,0.631 0.631,1.578 0.946,2.524c0.316,0.946 0.631,1.893 0.631,2.839c0.316,1.893 0,3.786 -0.315,5.678c-0.316,1.893 -0.947,3.47 -1.893,5.363l-3.155,7.256c-0.946,2.523 -2.208,5.363 -2.839,8.202c-0.631,3.154 -1.262,6.309 -0.946,9.779c0.315,6.624 3.47,12.618 7.255,17.035c1.893,1.261 4.101,1.892 5.994,1.261Z",
    style: {
      fillRule: "nonzero"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M150.158,266.246c44.164,0 80.126,-35.962 80.126,-80.442c-0,-44.164 -35.962,-80.126 -80.126,-80.126c-44.164,0 -80.126,35.962 -80.126,80.126c-0,44.48 35.962,80.442 80.126,80.442Zm-0,-148.896c37.855,0 68.454,30.6 68.454,68.454c-0,37.855 -30.599,68.455 -68.454,68.455c-37.855,-0 -68.455,-30.6 -68.455,-68.455c0,-37.854 30.6,-68.454 68.455,-68.454Z",
    style: {
      fillRule: "nonzero"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M259.306,0l-218.297,0c-8.832,0 -16.088,7.256 -16.088,16.088l0,267.824c0,8.832 7.256,16.088 16.088,16.088l217.982,0c8.832,0 16.088,-7.256 16.088,-16.088l-0,-267.824c-0,-8.832 -7.256,-16.088 -15.773,-16.088Zm4.101,283.596c-0,2.208 -1.893,4.101 -4.101,4.101l-218.297,0c-2.208,0 -4.1,-1.893 -4.1,-4.101l-0,-199.684l226.182,-0l0,199.684l0.316,0Zm-226.498,-211.356l-0,-56.152c-0,-2.208 1.892,-4.101 4.1,-4.101l217.982,0c2.208,0 4.1,1.893 4.1,4.101l0,56.152l-226.182,-0Z",
    style: {
      fillRule: "nonzero"
    }
  }), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 75.71,
    cy: 41.956,
    r: 14.196
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 224.606,
    cy: 41.956,
    r: 14.196
  })), /*#__PURE__*/React.createElement("path", {
    d: "M122.397,34.7l-8.517,0c-1.577,0 -2.839,1.262 -2.839,2.839l0,8.518c0,1.577 1.262,2.839 2.839,2.839l8.517,-0c1.578,-0 2.84,-1.262 2.84,-2.839l-0,-8.518c-0,-1.577 -1.262,-2.839 -2.84,-2.839Z",
    style: {
      fillRule: "nonzero"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M154.574,34.7l-8.517,0c-1.578,0 -2.839,1.262 -2.839,2.839l-0,8.518c-0,1.577 1.261,2.839 2.839,2.839l8.517,-0c1.577,-0 2.839,-1.262 2.839,-2.839l0,-8.518c0,-1.577 -1.262,-2.839 -2.839,-2.839Z",
    style: {
      fillRule: "nonzero"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M186.751,34.7l-8.518,0c-1.577,0 -2.839,1.262 -2.839,2.839l0,8.518c0,1.577 1.262,2.839 2.839,2.839l8.518,-0c1.577,-0 2.839,-1.262 2.839,-2.839l-0,-8.518c-0,-1.577 -1.262,-2.839 -2.839,-2.839Z",
    style: {
      fillRule: "nonzero"
    }
  }));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgDryer);
export default __webpack_public_path__ + "static/media/dryer.702e7a5a.svg";
export { ForwardRef as ReactComponent };